/* src/app/component/loader/loader.component.scss */
.global-loader-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader-svg-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.chrome-loader {
  width: 60px;
  height: 60px;
  animation: rotate 2s linear infinite;
}
.loader-path {
  stroke: #FF8C00;
  stroke-linecap: round;
  stroke-dasharray: 89, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
}
.loader-text {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  12% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  25% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  38% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  62% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  75% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  88% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
/*# sourceMappingURL=loader.component-5RVNAAGV.css.map */
